// extracted by mini-css-extract-plugin
module.exports = {"root":"header_root__fUxGr","hamburger":"header_hamburger__hBPns","title":"header_title__3EkoF","logoContainer":"header_logoContainer__2-4Z1","logo":"header_logo__3iSgw"};